







import { Vue, Component, Prop } from "@/shared/vuepack";

@Component
export default class WizardItem extends Vue {
  @Prop()
  link;

  @Prop()
  isNavigationEnabled: boolean;

  @Prop()
  cssClass: string;

  @Prop()
  stepText: string;

  get linkType () {
    return this.isNavigationEnabled ? "a" : "span";
  }
}
